import VectorTools from "./vectorTools";

export default class UIManager {

	constructor(args) {
		this.scene = args.scene;
		this.system = this.scene.system;

		this.activePopup = null;
		this.popups = {};

		this.updateTasks = [];
		this.cfg = this.system.controller.getConfig();
		this.fxTime = 0;
	}

	update(delta, deltaNormal) {
		for(let t of this.updateTasks) {
			t(delta, deltaNormal);
		}
	}

	pokeFX() {
		this.updateTasks = [this.fadeFX.bind(this)];
		this.system.display.settings.tracers = 6;
		this.system.display.settings.voltageSlop = 1;
		this.system.display.settings.accuracy = 6;
		this.fxTime = 1000;
	}
	
	fadeFX(delta, deltaNormal) {
		this.system.display.settings.tracers *= 1 - (0.2 * deltaNormal);
		this.system.display.settings.accuracy *= 1 - (0.2 * deltaNormal);
		this.system.display.settings.voltageSlop *= 1 - (0.25 * deltaNormal);
		this.system.display.settings.voltageSlop = Math.max(this.system.display.settings.voltageSlop, this.cfg.display.voltageSlop);
		this.fxTime -= delta;
		if(this.fxTime < 0) this.resetFX();
	}

	resetFX() {
		this.updateTasks = [];
		this.system.display.settings.tracers = this.cfg.display.tracers;
		this.system.display.settings.voltageSlop = this.cfg.display.voltageSlop;
		this.system.display.settings.accuracy = this.cfg.display.accuracy;
	}

	showPopup(def) {
		let scn = this.scene;
		let sys = this.system;
		let pal = sys.palette;
		let col = pal[def.color || 'white'];
		let vt = VectorTools.get();
		let f = sys.factory;
		let w = def.width;
		let mg = 10;
		let h = mg*3;
		let s = 1;
		let l = 1;
		let elem = null;

		scn.cleanUpUI();

		// pause all non UI game entities
		if(def.pause) {
			scn.paused = true;
		}

		this.pokeFX();

		let pop = {
			name: def.name,
			entities: []
		};

		// giant transparent rectangle, prevents clicks to layers beneath
		if(!def.transparent) {
			let shade = f.mask({
				name: 'shade',
				layer:'interface',
				x:'50%', y:'50%', scale:1.25,
				shape:`0 0 ${sys.screen.width} 0 ${sys.screen.width} ${sys.screen.height} 0 ${sys.screen.height}`,
				// color: 0x332020,
			});
			shade._bg = true;
			shade.sprite.g.alpha = 0.9;
			shade.sprite.g.eventMode = 'dynamic';
			pop.entities.push(shade);
		}

		// popup background
		let solid = f.mask({
			name: 'solid',
			layer:'interface',
			x:'50%', y:'50%', scale:1,
			shape:`0 0 ${w} 0 ${w} ${h} 0 ${h}`,
		});
		solid._bg = true;
		pop.entities.push(solid);

		// popup border
		let outline = f.poly({
			name: 'outline',
			layer:'interface',
			x:'50%', y:'50%', scale:1,
			color: col,
			shape:`0 0 ${w} 0 ${w} ${h} 0 ${h}`,
			closeShapes: true
		});
		outline._bg = true;
		outline.sprite.alpha = 0.15;
		outline.sprite.tracers = -10;
		pop.entities.push(outline);

		// parse UI item list
		for(let i of def.items) {
			switch(i.type) {

				// BrainSimpleText entity
				case 'text' :
					s = i.scale || 1.5;
					l = i.text.split('\n').length;
					h += mg;
					h += 6 * s * l;
					if(l > 1) h += l * 5;
					elem = f.text({
						layer: 'interface',
						x:'50%', y:'50% '+h, scale:s,
						color:i.color != undefined ? pal[i.color] : col,
						text:i.text,
					});
					h += 6 * s * l;
					if(l > 1) h += l * 5;
					h += mg;
					elem.sprite.alpha = 0.3;
					pop.entities.push(elem);
					break;
				
				// BrainSimpleButton entity
				// fires a callback when clicked
				case 'button' :
					s = i.scale || 1.5;
					h += mg;
					h += 15 * s;
					elem = f.button({
						x:'50%', y:'50% '+h, scale:s,
						layer:'interface',
						text:i.text,
						color:i.color != undefined ? pal[i.color] : col,
						onClick: i.onClick.bind(this),
					});
					h += 15 * s;
					h += mg;
					elem.sprite.alpha = 0.4;
					if(i.disabled) elem.brain.disable();
					pop.entities.push(elem);
					break;
				
				// BrainSimpleButton entity
				// cycles between a list of states, fires a callback when changed
				case 'switch' :
					s = i.scale || 1.5;
					h += mg;
					h += 15 * s;
					elem = f.button({
						x:'50%', y:'50% '+h, scale:s,
						layer:'interface',
						text:i.text,
						color:i.color != undefined ? pal[i.color] : col,
						onClick: this.handleSwitchButton.bind(this),
					});
					h += 15 * s;
					h += mg;
					elem.sprite.alpha = 0.4;
					if(i.disabled) elem.brain.disable();
					elem.brain.switchStates = i.states;
					elem.brain.switchIndex = i.initial == undefined ? 0 : elem.brain.switchStates.indexOf(i.initial);
					elem.brain.switchValue = elem.brain.switchStates[elem.brain.switchIndex];
					elem.brain.switchFunc = i.onSet.bind(this);
					pop.entities.push(elem);
					break;
				
				// horizontal line divider
				case 'divider' :
					h += mg*3;
					elem = f.poly({
						name:'divider',
						layer:'interface',
						x:'50%', y:'50% '+h, scale:1,
						color:i.color != undefined ? pal[i.color] : col,
						shape:`0 0 ${w} 0`,
					});
					h += mg*3;
					elem.sprite.alpha = 0.2;
					pop.entities.push(elem);
					break;

				// arbitrary spacing (defaults to 2x margin size)
				case 'space' :
					h += i.height || mg*2;
					break;
			}

			if(elem && i.ref) {
				this.scene[i.ref] = elem;
			}

			elem = null;
		}

		h += mg*3;

		// update window size
		let shape = [`0 0 ${w} 0 ${w} ${h} 0 ${h}`];
		solid.sprite.paths = vt.generatePathsFromShape({shape:shape});
		solid.sprite.redrawGraphics();
		outline.sprite.paths = vt.generatePathsFromShape({shape:shape});
		outline.sprite.redrawGraphics();

		// shift up
		for(let i of pop.entities) {
			if(!i._bg) i.sprite.position.y -= (h*0.5);
		}

		// pointers
		scn.uiEntities.push(...pop.entities);
		this.popups[def.name] = pop;
	}

	handleSwitchButton(e) {
		e.brain.switchIndex++;
		e.brain.switchIndex %= e.brain.switchStates.length;
		e.brain.switchValue = e.brain.switchStates[e.brain.switchIndex];
		e.brain.switchFunc(e, e.brain.switchValue);
	}

	closePopup(name) {
		let p = this.popups[name];
		for(let e of p.entities) {
			e.destroy();
		}
		delete this.popups[name];
		this.scene.cleanUpUI();
		this.pokeFX();
	}

}